<template>
  <div>
    <el-row class="price-item" v-for="(priceItem,priceIndex) in price" :key="'price_'+priceIndex"
            v-if="priceItem.is_del === false">
      <el-col :span="5" class="gutter">
        <el-select placeholder="请选择售价类型" v-model="priceItem.price_type"
                   style="width: 100%;"
                   @change="changeType(priceIndex)">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,index) in price_type"
                     :key="'option_'+index"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5" class="gutter">
        <el-input placeholder="请输入售价" v-model="priceItem.price"></el-input>
      </el-col>
      <el-col :span="5" class="gutter">
        <el-input placeholder="运营豆" v-model="priceItem.op_cost_price"></el-input>
      </el-col>
      <el-col :span="5" class="gutter">
        <el-date-picker
          type="date"
          style="width: 100%;"
          :disabled="priceItem.price_type !== 8"
          v-if="priceItem.price_type !== 9"
          v-model="priceItem.sale_date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>

        <el-select placeholder="请选择会员组" v-model="priceItem.group_id"
                   style="width: 100%;"
                   v-if="priceItem.price_type === 9">
          <el-option :label="group.name"
                     :value="group.id"
                     v-for="group in groups"
                     v-if="group.id != 1"
                     :key="'option_'+group.id"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-button size="mini" type="danger" @click="delPrice(priceIndex)">删除</el-button>
      </el-col>
    </el-row>
    <el-row class="price-item">
      <el-col :span="24">
        <el-button size="mini" type="success" plain @click="addPrice">
          <i class="el-icon-plus"></i>添加价格信息
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "i-price",
    props: {
      input: {
        type: Object,
      },
      value: {}
    },
    data: function () {
      return {
        price: [],
        price_type: [
          {
            label: "默认售价",
            value: 0
          },
          {
            label: "周一售价",
            value: 1
          },
          {
            label: "周二售价",
            value: 2
          },
          {
            label: "周三售价",
            value: 3
          },
          {
            label: "周四售价",
            value: 4
          },
          {
            label: "周五售价",
            value: 5
          },
          {
            label: "周六售价",
            value: 6
          },
          {
            label: "周日售价",
            value: 7
          },
          {
            label: "指定日期售价",
            value: 8
          },
          {
            label: "会员组售价",
            value: 9
          }
        ],
        groups: []
      }
    },
    methods: {
      addPrice: function () {
        this.price.push({
          price_type: '',
          price: '',
          op_cost_price: '',
          group_id: '',
          sale_date: '',
          is_del: false,
        });
      },
      delPrice: function (index) {
        if (this.price[index].hasOwnProperty('price_id')) {
          this.price[index].is_del = true;
        } else {
          this.price.splice(index, 1);
        }
      },
      changeType: function (index) {
        this.price[index].group_id = "";
        this.price[index].sale_date = "";
      },
      getGroupList:function () {
        this.$http.request('groupList').then(res => {
          this.groups = res.data;
        });
      }
    },
    created: function () {
      this.price = this.value;
      this.getGroupList();
    },
    watch: {
      price: function () {
        this.$emit('input', this.price);
      },
      value: function () {
        this.price = this.value;
      }
    }
  }
</script>

<style scoped lang="less">
  .gutter {
    margin-right: 5px;
  }

  .price-item {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/i-price.vue